export default __webpack_public_path__ + "static/media/19.c56fa5a2.png";